export const staticPrimaryColor = "#1FB43E";
export const themes = {
  light: {
    dark: false,
    colors: {
      primary: staticPrimaryColor,
      "on-primary": "#FFFFFF",
      secondary: "#2D3748",
      "on-secondary": "#FFFFFF",
      success: "#38A169",
      "on-success": "#FFFFFF",
      info: "#3182CE",
      "on-info": "#FFFFFF",
      warning: "#ECC94B",
      "on-warning": "#000000",
      error: "#E53E3E",
      background: "#F7FAFC",
      "on-background": "#1A202C",
      surface: "#FFFFFF",
      "on-surface": "#1A202C",
      "table-header": "#F7FAFC",
      "grey-50": "#F7FAFC",
      "grey-100": "#EDF2F7",
      "grey-200": "#E2E8F0",
      "grey-300": "#CBD5E0",
      "grey-400": "#A0AEC0",
      "grey-500": "#718096",
      "grey-600": "#4A5568",
      "grey-700": "#2D3748",
      "grey-800": "#1A202C",
      "grey-900": "#171923",
      "perfect-scrollbar-thumb": "#CBD5E0",
      "skin-bordered-background": "#FFFFFF",
      "skin-bordered-surface": "#FFFFFF",
    },
    variables: {
      "code-color": staticPrimaryColor,
      "overlay-scrim-background": "#111827",
      "tooltip-background": "#1F2937",
      "overlay-scrim-opacity": 0.5,
      "hover-opacity": 0.05,
      "focus-opacity": 0.1,
      "selected-opacity": 0.08,
      "activated-opacity": 0.1,
      "pressed-opacity": 0.15,
      "dragged-opacity": 0.05,
      "disabled-opacity": 0.4,
      "border-color": "#D1D5DB",
      "border-opacity": 0.2,
      "high-emphasis-opacity": 0.8,
      "medium-emphasis-opacity": 0.6,
      "switch-opacity": 0.3,
      "switch-disabled-track-opacity": 0.2,
      "switch-disabled-thumb-opacity": 0.5,
      "switch-checked-disabled-opacity": 0.4,

      // Shadows
      "shadow-key-umbra-color": "#1F2937",
    },
  },
  dark: {
    dark: true,
    colors: {
      primary: staticPrimaryColor,
      "on-primary": "#FFFFFF",
      secondary: "#A0AEC0",
      "on-secondary": "#000000",
      success: "#68D391",
      "on-success": "#000000",
      info: "#63B3ED",
      "on-info": "#000000",
      warning: "#F6E05E",
      "on-warning": "#000000",
      error: "#FC8181",
      background: "#1A202C",
      "on-background": "#EDF2F7",
      surface: "#2D3748",
      "on-surface": "#EDF2F7",
      "grey-50": "#2D3748",
      "grey-100": "#4A5568",
      "grey-200": "#718096",
      "grey-300": "#A0AEC0",
      "grey-400": "#CBD5E0",
      "grey-500": "#E2E8F0",
      "grey-600": "#EDF2F7",
      "grey-700": "#F7FAFC",
      "grey-800": "#FFFFFF",
      "grey-900": "#FFFFFF",
      "perfect-scrollbar-thumb": "#718096",
      "skin-bordered-background": "#2D3748",
      "skin-bordered-surface": "#2D3748",
    },
    variables: {
      "code-color": "#FF6B81",
      "overlay-scrim-background": "#0F172A",
      "tooltip-background": "#4B5563",
      "overlay-scrim-opacity": 0.6,
      "hover-opacity": 0.05,
      "focus-opacity": 0.1,
      "selected-opacity": 0.08,
      "activated-opacity": 0.1,
      "pressed-opacity": 0.15,
      "dragged-opacity": 0.05,
      "disabled-opacity": 0.4,
      "border-color": "#E5E7EB",
      "border-opacity": 0.2,
      "high-emphasis-opacity": 0.8,
      "medium-emphasis-opacity": 0.6,
      "switch-opacity": 0.3,
      "switch-disabled-track-opacity": 0.2,
      "switch-disabled-thumb-opacity": 0.5,
      "switch-checked-disabled-opacity": 0.4,

      // Shadows
      "shadow-key-umbra-color": "#0F172A",
    },
  },
};
export default themes;
